import { render, staticRenderFns } from "./PlaylistItem.vue?vue&type=template&id=75881810&scoped=true&"
import script from "./PlaylistItem.vue?vue&type=script&lang=ts&"
export * from "./PlaylistItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75881810",
  null
  
)

export default component.exports